import { useState, useEffect, useRef } from "react";
import { 
  subscribeToZones, 
  seedZonesIfEmpty,
  addZone,
  updateZone,
  deleteZone
} from "../services/zonesService";

export function useZones() {
  const [zones, setZones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const hasSeededRef = useRef(false);

  useEffect(() => {
    let unsubscribe = () => {};

    try {
      setLoading(true);
      unsubscribe = subscribeToZones(async (data, err) => {
        if (err) {
          setError("Failed to load warehouse zones.");
          setLoading(false);
          return;
        }

        setZones(data);
        setLoading(false);
      });
    } catch (err) {
      console.error(err);
      setError("Failed to initialize zones subscription.");
      setLoading(false);
    }

    return () => unsubscribe();
  }, []);

  const handleAddZone = async (zoneData) => {
    try {
      setError("");
      return await addZone(zoneData);
    } catch (err) {
      console.error("Error adding zone:", err);
      setError(err.message || "Failed to add zone.");
      throw err;
    }
  };

  const handleUpdateZone = async (id, zoneData) => {
    try {
      setError("");
      await updateZone(id, zoneData);
    } catch (err) {
      console.error("Error updating zone:", err);
      setError(err.message || "Failed to update zone.");
      throw err;
    }
  };

  const handleDeleteZone = async (id) => {
    try {
      setError("");
      await deleteZone(id);
    } catch (err) {
      console.error("Error deleting zone:", err);
      setError(err.message || "Failed to delete zone.");
      throw err;
    }
  };

  return {
    zones,
    loading,
    error,
    setError,
    addZone: handleAddZone,
    updateZone: handleUpdateZone,
    deleteZone: handleDeleteZone
  };
}
